module.exports = fox._r("images/logout-hover.png", __webpack_public_path__ + "images/logout-hover.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/logout-hover.png
// module id = 1078
// module chunks = 4